import { Component, Input, type SimpleChanges } from '@angular/core';

@Component({
  template: '',
  standalone: false
})
export abstract class ChatWidgetInputBase {
  /** When false, the widget's built-in question label is hidden. */
  @Input() showLabel = true;
  /** When true, the widget is read-only because an earlier instance superseded it. */
  @Input() locked = false;

  protected onlyLockedChanged(changes: SimpleChanges): boolean {
    return Object.keys(changes).length === 1 && !!changes['locked'];
  }
}
